'use strict';

const DbErrorDirective = [function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link(scope, element, attrs, ngModel) {
      element.on('keydown', function() {
        return ngModel.$setValidity('database', true);
      });
    }
  };
}];

export default DbErrorDirective;
